// utils/evalExpr.ts
import { Parser } from "expr-eval-fork";

const parser = new Parser({
  operators: {
    // arithmetic
    add: true,
    subtract: true,
    multiply: true,
    divide: true,
    power: true,
    remainder: true,
    factorial: true,

    // logic / comparisons / ternary
    logical: true,
    comparison: true,
    conditional: true,

    // string concat (usually disable)
    concatenate: false,
  },
  // block things like a.b / obj['x']
  allowMemberAccess: false,
});

export function evalExpr(
  expr: string,
  vars: Record<string, number | null | undefined>,
): number | null {
  // whitelist variables like x0, x1, x100...
  const scope: Record<string, number> = {};
  for (const [k, v] of Object.entries(vars)) {
    if (/^x\d+$/.test(k) && typeof v === "number" && Number.isFinite(v)) {
      scope[k] = v;
    }
  }

  try {
    // compile if you’ll reuse the same expr often:
    // const fn = parser.parse(expr); return Number(fn.evaluate(scope));
    return Number(parser.evaluate(expr, scope));
  } catch {
    return null;
  }
}
